import { styled } from '@acko-tech/building-blocks.ui.common';

export const Wrapper = styled.div``;
